import React from 'react'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from 'react-router-dom';


const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
const Slide = ({products, title}) => {
  return (
    <>  
      <div className='p-[8px] mx-[12px] my-[20px] bg-green-100 shadow-lg'>
        <div className='text-[20px] font-bold'>{title}</div>
       <Carousel
        swipeable={false}
        draggable={false}
        showDots={true}
        responsive={responsive}
        ssr={true} // means to render carousel on server-side.
        infinite={true}
        // autoPlay={this.props.deviceType !== "mobile" ? true : false}
        autoPlay={false}
        keyBoardControl={true}
        customTransition="all .5"
        transitionDuration={5000}
        containerClass="carousel-container"
        removeArrowOnDeviceType={["tablet", "mobile"]}
        // deviceType={this.props.deviceType}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px"
        
      >
        {products.map((product, idx) => {
          return (
            <Link to={`product/${product.id}`}>
              <div key={idx} className="cursor-pointer  p-[8px] rounded-lg">
                <img src={product.url} alt="" className='h-[200px] w-[150px]'/>
                <p>{product.title.shortTitle}</p>
                <p>{product.discount}</p>
                <p>{product.tagline}</p>
              </div>
            </Link>
          );
        })}
      </Carousel>
      </div>
    </>
  )
}

export default Slide
